export default "__VITE_ASSET__CsU0aMow__"